/**
 * Mirror of the server's `app/auth/deps.py:has_right`:
 * an account with `owner` in its rights list passes every check,
 * current and future. Use this anywhere the SPA gates UI on a
 * specific right (Admin nav, profile-side admin features, etc.).
 */
export const OWNER_RIGHT = "owner";
export const ADMIN_RIGHT = "admin";
/** Dedicated operator right for the Marketplaces section. A
 *  `marketplace` account runs the integration without admin access;
 *  `admin` and `owner` reach it too (mirrors the server's
 *  `require_any_right("admin", "marketplace")`). */
export const MARKETPLACE_RIGHT = "marketplace";
/** Dedicated right for the Bybit money console (/bybit): balances,
 *  transfers, spot, Earn, withdrawals. Granted to trusted employees;
 *  `owner` bypasses as usual (mirrors `require_right("bybit")`). */
export const BYBIT_RIGHT = "bybit";

/** True if the user holds ANY of `rights` (owner bypasses every
 *  check, same as {@link userHasRight}). */
export function userHasAnyRight(
  rights: string[] | undefined,
  wanted: string[],
): boolean {
  return wanted.some((r) => userHasRight(rights, r));
}

export function userHasRight(
  rights: string[] | undefined,
  right: string,
): boolean {
  if (!rights) return false;
  return rights.includes(right) || rights.includes(OWNER_RIGHT);
}
